export default __webpack_public_path__ + "static/media/svg-3.c9670f1d.svg";